import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Is it more expensive if I have an agent?' },
	{
		name: 'description',
		content:
			'You might be surprised to learn that having an agent is often less costly.',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/frequently-asked-questions/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				Frequently Asked Questions
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">Is an agent more expensive?</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<strong>Is it more expensive to buy insurance from an agent?</strong>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Some people have come to us with apprehension because they feel that
				buying a policy through an agent is more expensive than buying a policy
				on your own. This thinking is misguided. All policies that are sold have
				to be sold by someone that possesses an insurance agent's license, so
				there's always an agent. Some companies advertise heavily that insurance
				is simple enough that anyone can do it. The constant bombardment of
				advertising messages can lead a person to believe that “everybody saves
				15%.” These ad campaigns are designed to trigger a curiosity that can
				cause a person to shop around and is a way that insurers can generate a
				stream of new policyholders. In the end, the high cost of advertising
				can actually lead to a much higher cost structure for the policy.
				Sometimes the first six months or one year of a new policy from an
				insurer like this is offered at a discounted rate, but in fact the rate
				goes up after this honeymoon period is over.
			</p>
		</main>
	)
}
